import { useLoaderData } from 'react-router';

import type { FeatureFlags, FeatureFlagValue } from '~/utils/featureFlags';

type LoaderData = {
  exposedFlags?: string[];
  featureFlags?: FeatureFlags;
};

export function useIsExperimentReported(flag: string): boolean {
  const data = useLoaderData() as LoaderData | undefined;

  return Boolean(data?.exposedFlags?.includes(flag));
}

export default function useFeatureFlag(
  flag: string
): FeatureFlagValue | undefined {
  const data = useLoaderData() as LoaderData | undefined;

  return data?.featureFlags?.[flag];
}
